import React, { Fragment } from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { IFormatter } from '@kurtosys/types/data/IFormatter.js';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { ITranslationContextValue } from '../Translate/models/index.js';
import Translate, { TranslationContext } from '../Translate/Translate.js';

import { IAsOfDateConfiguration, IAsOfDateProps, IAsOfDateState } from './models/index.js';
import DateWrapper from './styledComponents/DateWrapper.js';
import Title from './styledComponents/Title.js';
import Wrapper from './styledComponents/Wrapper.js';
import { AS_OF_DATE_CATEGORY_KEY, AS_OF_DATE_COMPONENT_KEY } from './AsOfDate.meta.js';

export class AsOfDate extends ComponentBase<IAsOfDateProps, IAsOfDateState, IAsOfDateConfiguration> {
	categoryKey = AS_OF_DATE_CATEGORY_KEY;
	componentKey = AS_OF_DATE_COMPONENT_KEY;

	static defaultProps: IAsOfDateProps = {
		text: 'As of {date}',
	};

	constructor(props: IAsOfDateProps) {
		super(props);
	}
	getDate = (translationContext: ITranslationContextValue) => {
		const { formatOverride, date, dateFormat = 'date', placeholderText } = this.props;
		const globalFormat =
			this.globalConfiguration &&
			this.globalConfiguration.formats &&
			this.globalConfiguration.formats[dateFormat];
		const format = formatOverride || globalFormat;
		if (date) {
			if (format) {
				if (!format.locale) {
					format.locale = translationContext && translationContext.culture;
				}
				if (!format.options) {
					format.options = {};
				}
				return common.commonUtils.formatter(format as IFormatter, date);
			}
			return date;
		}
		return placeholderText;
	};
	render() {
		const { className, text, title, showBlank = true } = this.props;
		const hasTitle = !common.commonUtils.isNullOrEmpty(title);
		return (
			<Wrapper className={className}>
				<TranslationContext.Consumer>
					{(translationContext) => {
						const date = this.getDate(translationContext);
						return (
							(showBlank || date) && (
								<Fragment>
									{hasTitle && (
										<Title>
											<Translate>{title}</Translate>
										</Title>
									)}
									<DateWrapper>
										<Translate placeholders={{ date }}>{text}</Translate>
									</DateWrapper>
								</Fragment>
							)
						);
					}}
				</TranslationContext.Consumer>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(AsOfDate), AS_OF_DATE_CATEGORY_KEY, AS_OF_DATE_COMPONENT_KEY);
